import React from 'react';
import EvaluationButton from './EvaluationButton';

const EvaluationAddButton = ({ onClick, children, className = "" }) => {
    return (
        <EvaluationButton 
            onClick={onClick} 
            variant="light" 
            className={`w-full py-3 border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-gray-400 text-gray-600 font-medium transition-all ${className}`}
        >
            {children}
        </EvaluationButton>
    );
};

export default EvaluationAddButton;
